import { handleActions, combineActions } from 'redux-actions';
import { LOAD_CONFIG } from '../constants';

const intialState = {
  loading: false,
  ready: false,
  error: false,
};

const configReducer = handleActions(
  {
    [LOAD_CONFIG.PENDING]: state => ({
      ...state,
      loading: true,
      error: false,
    }),
    [combineActions(
      LOAD_CONFIG.CANCELLED,
      LOAD_CONFIG.SUCCESS,
      LOAD_CONFIG.ERROR,
    )]: state => ({
      ...state,
      loading: false,
    }),
    [LOAD_CONFIG.SUCCESS]: state => ({
      ...state,
      ready: true,
      error: false,
    }),
    [LOAD_CONFIG.ERROR]: state => ({
      ...state,
      error: true,
    }),
  },
  intialState,
);

export default configReducer;
